import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglass01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.651 21.6H17.35c.605 0 1.097-.491 1.097-1.097v-2.931c0-.234-.075-.462-.214-.65l-3.164-4.295a1.1 1.1 0 0 1-.022-1.27l2.934-4.288c.125-.183.192-.399.192-.62V3.497c0-.606-.492-1.097-1.098-1.097H6.651c-.605 0-1.097.491-1.097 1.097v2.931c0 .234.075.462.214.65l3.147 4.271c.285.387.285.915 0 1.302l-3.147 4.27a1.1 1.1 0 0 0-.214.651v2.93c0 .607.492 1.098 1.097 1.098"
    />
  </svg>
);
export default SvgHourglass01;
